/* eslint-disable prettier/prettier */
import { html, nothing } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";

import { VideoSource, VideoTemplateParameter } from "./sc-e-lazy-video.types";

const renderSource = (source: VideoSource) => {
  return html`<source class="sc-e-lazy-video__sources" data-src="${source.src}" type="${source.type}" />`;
  
};

const renderVideoSources = (args: VideoTemplateParameter) => {
  if (args.sources === undefined) return "";
  return args.sources.map(source => renderSource(source));
};

const renderAriaPlayPause = (args: VideoTemplateParameter) => {
  if (args.component.ariaPlayPauseButton === false) return nothing;
  return html`
    <button aria-label="${args.component.ariaPlayButtonLabel}" class="sc-e-button sc-e-button--light-interactions sc-e-button--icon-only sc-e-lazy-video__aria-pause-play-button sc-e-lazy-video__aria-pause-play-button--play">
      <sc-e-icon class="sc-e-icon sc-e-button__icon" icon-id="sc-icon-play"></sc-e-icon>
    </button>
    <button aria-label="${args.component.ariaPauseButtonLabel}" class="sc-e-button sc-e-button--light-interactions sc-e-button--icon-only sc-e-lazy-video__aria-pause-play-button sc-e-lazy-video__aria-pause-play-button--pause">
      <sc-e-icon class="sc-e-icon sc-e-button__icon" icon-id="sc-icon-pause"></sc-e-icon>
    </button>
  `;
};

const renderPosterImage = (args: VideoTemplateParameter) => {
  return html`
    <sc-e-lazy-image
      class="sc-e-lazy-image sc-e-lazy-video__poster sc-js-lazy-image"
      src="${ifDefined(args.component.posterSrc)}"
      srcset="${ifDefined(args.component.posterSrcSet)}"
      sizes="${ifDefined(args.component.posterSizes)}"
      loading-placeholder=${ifDefined(args.component.posterLoadingPlaceholder)}
      alt="${ifDefined(args.component.posterAlt)}"
      title="${ifDefined(args.component.posterTitle)}"
      aspect-ratio="${ifDefined(args.component.aspectRatio)}"
    >
    </sc-e-lazy-image>
  `;
}

const getPosterImage = (args: VideoTemplateParameter) => {
  return html`
    <button class="sc-e-lazy-video__play-cta" aria-label="${args.component.ariaPlayButtonLabel}">
      ${(args.component.posterSrc === undefined) ? nothing : renderPosterImage(args)}
      <div class="sc-e-lazy-video__play-icon-box">
        <sc-e-icon class="sc-e-lazy-video__play-icon" icon-id="sc-icon-play"></sc-e-icon>
      </div>
      <div class="sc-e-lazy-video__loading-spinner">
        <div class="sc-e-lazy-video__loading-bounce"></div>
        <div class="sc-e-lazy-video__loading-bounce"></div>
      </div>
    </button>
  `;
};

export const videoTemplate = (args: VideoTemplateParameter) => {
  return html`
    <video class="sc-e-lazy-video__video" 
           @loadeddata=${() => args.component.handleVideoLoad()}
           ?muted=${args.component.muted}
           autobuffer
           preload
           ?controls=${args.component.controls}
           ?autoplay=${!args.component.paused}
           ?loop=${!args.component.noLoop} 
           playsinline>
      ${renderVideoSources(args)}
    </video>
    ${getPosterImage(args)}
    ${renderAriaPlayPause(args)}
  `;
};
